import React from 'react';
import { Modal, ModalHeader, ModalBody, Table } from 'reactstrap';


const Attendees = (props) => {

    return (
        <Modal isOpen={props.modal} size='lg' toggle={() => props.toggle(false)}>
            <ModalHeader toggle={() => props.toggle(false)}>Attendees</ModalHeader>
            <ModalBody>
                <Table style={{ width: '100%' }}>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>D.O.B</th>
                            <th>ID</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.registrant && (
                            <tr>
                                <td style={{ width: "33.33%" }}>{props.registrant.name} <small style={{ color: '#888' }}>(Registrant)</small></td>
                                <td style={{ width: "33.33%" }}>{props.registrant.dob ? new Date(props.registrant.dob).toLocaleDateString() : '—'}</td>
                                <td style={{ width: "33.33%" }}>{props.registrant.validId}</td>
                            </tr>
                        )}
                        {props.guests?.map((guest, i) => (
                            <tr key={i}>
                                <td style={{ width: "33.33%" }}>{guest.name}</td>
                                <td style={{ width: "33.33%" }}>{new Date(guest.dob).toLocaleDateString()}</td>
                                <td style={{ width: "33.33%" }}>{guest.validId}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </ModalBody>
        </Modal>
    );
}

export default Attendees;